
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Request} from '../core/Request';
import {FieldModelRequest} from '../core/Request';
import {AccountsArchivedGetPageResponse} from './AccountsArchivedGetPageResponse';
import {AccountsFiltration} from '../core/AccountsFiltration';
import {FieldModelAccountsFiltration} from '../core/AccountsFiltration';
import {AccountsSorting} from '../core/AccountsSorting';
import {FieldModelAccountsSorting} from '../core/AccountsSorting';

/**
 * AccountsArchivedGetPageRequest struct
 */
class AccountsArchivedGetPageRequest extends Request {
  /**
   * Initialize struct
   * @param {!Request=} parent
   * @param {!AccountsFiltration=} accountsFiltration
   * @param {!AccountsSorting=} accountsSorting
   * @param {!number=} pageSize
   * @param {!number=} pageNumberZeroBased
   * @constructor
   */
  constructor (parent = new Request(), accountsFiltration = new AccountsFiltration(), accountsSorting = new AccountsSorting(), pageSize = new UInt64(20, 0), pageNumberZeroBased = new UInt64(0, 0)) {
    super()
    super.copy(parent)
    this.AccountsFiltration = accountsFiltration
    this.AccountsSorting = accountsSorting
    this.PageSize = pageSize
    this.PageNumberZeroBased = pageNumberZeroBased
  }

  /**
   * Copy struct (shallow copy)
   * @this {!AccountsArchivedGetPageRequest}
   * @param {!AccountsArchivedGetPageRequest} other Other struct
   * @returns {!AccountsArchivedGetPageRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.AccountsFiltration != null) {
      this.AccountsFiltration = AccountsFiltration.fromObject(other.AccountsFiltration)
    } else {
      this.AccountsFiltration = null
    }
    if (other.AccountsSorting != null) {
      this.AccountsSorting = AccountsSorting.fromObject(other.AccountsSorting)
    } else {
      this.AccountsSorting = null
    }
    if (other.PageSize != null) {
      this.PageSize = UInt64.fromNumber(other.PageSize)
    } else {
      this.PageSize = null
    }
    if (other.PageNumberZeroBased != null) {
      this.PageNumberZeroBased = UInt64.fromNumber(other.PageNumberZeroBased)
    } else {
      this.PageNumberZeroBased = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!AccountsArchivedGetPageRequest}
   * @returns {!AccountsArchivedGetPageRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new AccountsArchivedGetPageRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new AccountsArchivedGetPageRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!AccountsArchivedGetPageRequest}
   * @param {!AccountsArchivedGetPageRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof AccountsArchivedGetPageRequest)) {
      throw new TypeError('Instance of AccountsArchivedGetPageRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!AccountsArchivedGetPageRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      AccountsFiltration: ((this.AccountsFiltration != null) ? this.AccountsFiltration : null),
      AccountsSorting: ((this.AccountsSorting != null) ? this.AccountsSorting : null),
      PageSize: ((this.PageSize != null) ? this.PageSize.toNumber() : null),
      PageNumberZeroBased: ((this.PageNumberZeroBased != null) ? this.PageNumberZeroBased.toNumber() : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return AccountsArchivedGetPageRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!AccountsArchivedGetPageRequest} other Object value
   * @returns {!AccountsArchivedGetPageRequest} Created struct
   */
  static fromObject (other) {
    return new AccountsArchivedGetPageRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!AccountsArchivedGetPageRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return AccountsArchivedGetPageRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!AccountsArchivedGetPageRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6650
  }
}

export { AccountsArchivedGetPageRequest };

/**
 * Fast Binary Encoding AccountsArchivedGetPageRequest field model
 */
class FieldModelAccountsArchivedGetPageRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelRequest(buffer, 4 + 4)
    this.AccountsFiltration = new FieldModelAccountsFiltration(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.AccountsSorting = new FieldModelAccountsSorting(buffer, this.AccountsFiltration.fbeOffset + this.AccountsFiltration.fbeSize)
    this.PageSize = new fbe.FieldModelUInt64(buffer, this.AccountsSorting.fbeOffset + this.AccountsSorting.fbeSize)
    this.PageNumberZeroBased = new fbe.FieldModelUInt64(buffer, this.PageSize.fbeOffset + this.PageSize.fbeSize)
  }

  /**
   * Get the core.Request field model
   * @this {!FieldModelAccountsArchivedGetPageRequest}
   * @returns {!FieldModelRequest} core.Request field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelAccountsArchivedGetPageRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelAccountsArchivedGetPageRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.AccountsFiltration.fbeSize + this.AccountsSorting.fbeSize + this.PageSize.fbeSize + this.PageNumberZeroBased.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelAccountsArchivedGetPageRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.AccountsFiltration.fbeExtra + this.AccountsSorting.fbeExtra + this.PageSize.fbeExtra + this.PageNumberZeroBased.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelAccountsArchivedGetPageRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelAccountsArchivedGetPageRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelAccountsArchivedGetPageRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6650
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelAccountsArchivedGetPageRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelAccountsArchivedGetPageRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.AccountsFiltration.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountsFiltration.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountsFiltration.fbeSize

    if ((fbeCurrentSize + this.AccountsSorting.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountsSorting.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountsSorting.fbeSize

    if ((fbeCurrentSize + this.PageSize.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.PageSize.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PageSize.fbeSize

    if ((fbeCurrentSize + this.PageNumberZeroBased.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.PageNumberZeroBased.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PageNumberZeroBased.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelAccountsArchivedGetPageRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelAccountsArchivedGetPageRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelAccountsArchivedGetPageRequest}
   * @param {!AccountsArchivedGetPageRequest} fbeValue Default value, defaults is new AccountsArchivedGetPageRequest()
   * @returns {!AccountsArchivedGetPageRequest} AccountsArchivedGetPageRequest value
   */
  get (fbeValue = new AccountsArchivedGetPageRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelAccountsArchivedGetPageRequest}
   * @param {!AccountsArchivedGetPageRequest} fbeValue AccountsArchivedGetPageRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.AccountsFiltration.fbeSize) <= fbeStructSize) {
      fbeValue.AccountsFiltration = this.AccountsFiltration.get()
    } else {
      fbeValue.AccountsFiltration = new AccountsFiltration()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountsFiltration.fbeSize

    if ((fbeCurrentSize + this.AccountsSorting.fbeSize) <= fbeStructSize) {
      fbeValue.AccountsSorting = this.AccountsSorting.get()
    } else {
      fbeValue.AccountsSorting = new AccountsSorting()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountsSorting.fbeSize

    if ((fbeCurrentSize + this.PageSize.fbeSize) <= fbeStructSize) {
      fbeValue.PageSize = this.PageSize.get(new UInt64(20, 0))
    } else {
      fbeValue.PageSize = new UInt64(20, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PageSize.fbeSize

    if ((fbeCurrentSize + this.PageNumberZeroBased.fbeSize) <= fbeStructSize) {
      fbeValue.PageNumberZeroBased = this.PageNumberZeroBased.get(new UInt64(0, 0))
    } else {
      fbeValue.PageNumberZeroBased = new UInt64(0, 0)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.PageNumberZeroBased.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelAccountsArchivedGetPageRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelAccountsArchivedGetPageRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelAccountsArchivedGetPageRequest}
   * @param {!AccountsArchivedGetPageRequest} fbeValue AccountsArchivedGetPageRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelAccountsArchivedGetPageRequest}
   * @param {AccountsArchivedGetPageRequest} fbeValue AccountsArchivedGetPageRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.AccountsFiltration.set(fbeValue.AccountsFiltration)
    this.AccountsSorting.set(fbeValue.AccountsSorting)
    this.PageSize.set(fbeValue.PageSize)
    this.PageNumberZeroBased.set(fbeValue.PageNumberZeroBased)
  }
}

export { FieldModelAccountsArchivedGetPageRequest };

/**
 * Fast Binary Encoding AccountsArchivedGetPageRequest model
 */
class AccountsArchivedGetPageRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelAccountsArchivedGetPageRequest(this.buffer, 4)
  }

  /**
   * Get the AccountsArchivedGetPageRequest model
   * @this {!AccountsArchivedGetPageRequestModel}
   * @returns {!FieldModelAccountsArchivedGetPageRequest} model AccountsArchivedGetPageRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!AccountsArchivedGetPageRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!AccountsArchivedGetPageRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return AccountsArchivedGetPageRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!AccountsArchivedGetPageRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelAccountsArchivedGetPageRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!AccountsArchivedGetPageRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!AccountsArchivedGetPageRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!AccountsArchivedGetPageRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!AccountsArchivedGetPageRequestModel}
   * @param {!AccountsArchivedGetPageRequest} value AccountsArchivedGetPageRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!AccountsArchivedGetPageRequestModel}
   * @param {!AccountsArchivedGetPageRequest} value AccountsArchivedGetPageRequest value, defaults is new AccountsArchivedGetPageRequest()
   * @return {!object} Deserialized AccountsArchivedGetPageRequest value and its size
   */
  deserialize (value = new AccountsArchivedGetPageRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new AccountsArchivedGetPageRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new AccountsArchivedGetPageRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!AccountsArchivedGetPageRequestModel}
   * @param {!number} prev Previous AccountsArchivedGetPageRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { AccountsArchivedGetPageRequestModel };
AccountsArchivedGetPageRequest.__has_response = true;
AccountsArchivedGetPageRequest.__response_class = AccountsArchivedGetPageResponse;
